import { useMutation, useQueryClient } from "@tanstack/react-query";
import { voidPurchaseRefund } from "api/purchaseRefund.api";
import {
  invalidatePurchaseRefundSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useVoidPurchaseRefund = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => voidPurchaseRefund(id, { reason }),
    onSuccess: () => {
      invalidatePurchaseRefundSide(queryClient);
      invalidateVendorSide(queryClient);
    },
  });
};
